/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo } from "react";

import { Link } from "react-router-dom";

// MaterialReactTable
import { MaterialReactTable } from "material-react-table";
import { defaultTableConfig, withStrictFilter } from "Config/tableConfig";
import * as XLSX from "xlsx";

//api url requirement
import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";

//import context
import { GlobalProvider } from "context/GlobalContext";

//import translation function for language translation
import { useTranslation } from "react-i18next";

import { assetImages } from "constants";

const EmployeeLogList = ({
  downloadExcel,
  search,
  setRecords,
  checkedRecordCount,
}) => {
  const token = localStorage.getItem("token"); // token
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const todayValue = new Date().toISOString().split("T")[0];

  const { t } = useTranslation(); //for translation

  const {
    screenHeight,
    reloadEmployeeLogList,
    setReloadEmployeeLogList,
    filterEmployeeLogDates,
    filterEmployeeLogUsers,
  } = useContext(GlobalProvider);

  const [LogList, setLogList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return LogList.filter((item) => selectedIds.includes(item._id));
  };

  /* Excel export */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : LogList;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Employeelogs.xlsx");
  };

  /* function to get all log data */
  const getAllLogList = async (currentSearch = search) => {
    setIsLoading(true);
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_EMPLOYEE_LOGS + `?token=${token}`;

      if (filterEmployeeLogDates != "") {
        requestUrl = requestUrl + `&filterdates=${filterEmployeeLogDates}`;
      } else {
        requestUrl = requestUrl + `&filterdates=${todayValue},${todayValue}`;
      }

      if (filterEmployeeLogUsers.length > 0) {
        requestUrl = requestUrl + `&filterusers=${filterEmployeeLogUsers}`;
      }

      if (currentSearch?.trim()) {
        requestUrl += `&globalsearch=${encodeURIComponent(currentSearch.trim())}`;
      }

      const response = await getData(requestUrl);

      console.log("log list response ========>>>", response);

      if (response.data) {
        setLogList(response.data);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  /* custom title html */
  const userHtml = ({ dataItem }) => {
    return (
      <div className="title kendoCustomColumn overflow-visible">
        <div className="d-flex align-items-center gap-2">
          <span>{dataItem.owner}</span>
        </div>
      </div>
    );
  };

  //complete status html
  const statusHtml = ({ dataItem }) => {
    return (
      <div className="activity">
        <span
          className={
            dataItem.completedpercent == "0"
              ? "text-orange"
              : dataItem.completedpercent == "3"
              ? "text-green"
              : dataItem.completedpercent == "1"
              ? "text-primary"
              : "text-secondary"
          }
        >
          {dataItem.taskstatus}
        </span>
      </div>
    );
  };

  // Column definitions
  const tableColumns = useMemo(() => withStrictFilter([
    {
      id: "owner",
      accessorKey: "owner",
      header: t("Employee"),
      size: 250,
    },
    {
      id: "employelogdate",
      accessorKey: "employelogdate",
      header: t("Date"),
      size: 200,
    },
    {
      id: "starttime",
      accessorKey: "starttime",
      header: t("Start Time"),
      size: 200,
    },
    {
      id: "endtime",
      accessorKey: "endtime",
      header: t("End Time"),
      size: 200,
    },
    {
      id: "workhour",
      accessorKey: "workhour",
      header: t("Log Hour"),
      size: 200,
    },
    {
      id: "taskcount",
      accessorKey: "taskcount",
      header: t("Task Completed"),
      size: 200,
    },
    {
      id: "taskcompletedcount",
      accessorKey: "taskcompletedcount",
      header: t("Task Pending"),
      size: 200,
    },
  ]), [LogList]);

  useEffect(() => {
    if (filterEmployeeLogDates != "" || filterEmployeeLogUsers.length > 0) {
      getAllLogList();
    }
  }, [filterEmployeeLogDates, filterEmployeeLogUsers]);

  /* hook to reload list */
  useEffect(() => {
    if (reloadEmployeeLogList) {
      getAllLogList();
      setReloadEmployeeLogList(false);
    }
  }, [reloadEmployeeLogList]);

  /* initial load + refetch when search changes */
  useEffect(() => {
    getAllLogList(search);
  }, [search]);

  /* set records based on LogList changes */
  useEffect(() => {
    setRecords(LogList.length);
  }, [LogList]);

  /* hook to hit exportExcel() function */
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* sync selected count to parent */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    checkedRecordCount(selectedCount);
  }, [rowSelection, LogList]);

  return (
    <div className="table-responsive rearrangeColumn">
      <MaterialReactTable
        {...defaultTableConfig}
        enableGlobalFilter
        globalFilterFn="strictContains"
        columns={tableColumns}
        data={LogList}
        enableSorting
        enableGrouping
        enableColumnOrdering
        enableStickyHeader
        enableRowSelection
        onRowSelectionChange={setRowSelection}
        onColumnFiltersChange={setColumnFilters}
        getRowId={(row) => row._id}
        state={{ rowSelection, columnFilters, isLoading }}
        renderLoadingOverlay={() => null}
        muiLinearProgressProps={{ sx: { display: "none" } }}
        muiCircularProgressProps={{ sx: { display: "none" } }}
        muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
        muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
        muiTableBodyProps={{ sx: { overflow: "visible" } }}
      />
    </div>
  );
};

export default EmployeeLogList;
